parasails.registerPage('display', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    isRotating: false
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
    // no-op
  },
  mounted: async function() {
    // Now, proceed with the WebSocket logic using the eventid.
    io.socket.on(this.eventid, (params) => {
      switch(params.eventType) {
        case 'refresh-qr':
          if(params.urlslug === this.urlslug) {
            window.location.reload();
          }
          break;
      }
    });

    var pageElement = document.getElementById('display');
    if (pageElement) {
      pageElement.addEventListener('click', this.rotateQr);
    }
  },
  beforeDestroy: function() {
    var pageElement = document.getElementById('display');
    if (pageElement) {
      pageElement.removeEventListener('click', this.rotateQr);
    }
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    rotateQr: function() {
      if (this.isRotating) {
        return;
      }

      this.isRotating = true;
      io.socket.post('/rally/rotate-qr', {
        eventId: this.eventid,
        urlslug: this.urlslug
      }, () => {
        this.isRotating = false;
      });
    }
  }
});
